import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView, updatePageContext } from '../lib/analytics'

/**
 * Fires GA4 page_view on every SPA route change and updates the
 * shared page context so subsequent events inherit the correct page.
 * Mount inside <BrowserRouter> before <Routes>.
 */
export default function RouteTracker() {
  const location = useLocation()
  const lastPath = useRef('')

  useEffect(() => {
    const fullPath = location.pathname + location.search
    if (fullPath === lastPath.current) return
    lastPath.current = fullPath

    const title = document.title
    updatePageContext(fullPath, title)
    trackPageView(fullPath, title)
  }, [location])

  return null
}
